import React from 'react';
import { DivergenceItem } from 'store/modules/contract_analysis/types';
import { Container } from './styles';

interface DivergencesTableProps {
  divergences: DivergenceItem[] | undefined;
}

const DivergencesTable = ({ divergences }: DivergencesTableProps) => {
  if (!divergences?.length) {
    return (
      <Container>
        <div className="alert alert-light border d-flex align-items-center">
          <i className="material-icons text-warning mr-2">warning</i>
          <strong className="mr-2">Não foram encontradas Divergências</strong>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="table-responsive bg-white">
        <table className="table table-bordered table-hover">
          <thead className="thead-light">
            <tr>
              <th>Minuta do Edital</th>
              <th>Contrato Recebido</th>
              <th>Descrição da Divergência</th>
            </tr>
          </thead>

          <tbody>
            {divergences.map((item) => (
              <tr key={`${item.clausula_referencia}-${item.contrato_recebido}`}>
                <td>{item.minuta_edital}</td>
                <td>{item.contrato_recebido}</td>
                <td>{item.descricao_divergencia}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Container>
  );
};

export default DivergencesTable;
